import { render, staticRenderFns } from "./BaseAlerts.vue?vue&type=template&id=6cdf603e&scoped=true&"
import script from "./BaseAlerts.vue?vue&type=script&lang=js&"
export * from "./BaseAlerts.vue?vue&type=script&lang=js&"
import style0 from "./BaseAlerts.vue?vue&type=style&index=0&id=6cdf603e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cdf603e",
  null
  
)

export default component.exports